const conversionUtils = {
  // https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript
  formatBytes(bytes: number | null | undefined): string {
    if (!bytes || bytes === 0) return '0 bytes';

    const k = 1024;
    const sizes = ['bytes', 'kb', 'mb', 'gb', 'tb', 'pb'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(0)) + sizes[i];
  },
};

export default conversionUtils;
